// @ts-strict-ignore
import {Injectable} from "@angular/core";
import {GlobalEventEmitterService} from "@event-emitter";

@Injectable({
	providedIn: "root",
})
export class SimBrowserCapabillitiesService {
	constructor(private _emitterService: GlobalEventEmitterService) {
		let connection = window.navigator["connection"];
		console.log(connection);

		if (connection && connection.addEventListener) {
			connection.addEventListener("change", () => {
				this._emitterService.onNetworkChanged.next();
			});
		}
	}

	public getBrowserWidth(): number {
		return window.innerWidth;
	}

	public getBrowserHeight(): number {
		return window.innerHeight;
	}

	public getNetworkConnectionSpeed(): "slow" | "medium" | "fast" {
		let connection: any = window.navigator["connection"];

		if (connection) {
			if (connection.type === "wifi" || connection.type === "cellular") {
				return "slow";
			} else {
				if (connection.effectiveType && connection.effectiveType !== "4g") {
					return "slow";
				} else {
					return "fast";
				}
			}
		} else {
			return "fast";
		}
	}
}
